import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Button, CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";
import { SECTION_COLORS } from "../../../constants";

const DeleteCouponTypeDialog = ({ open, couponType, onClose, onConfirm, deleting }) => {
    if (!couponType) return null;
    return (
        <Dialog open={open} onClose={!deleting ? onClose : undefined} maxWidth="xs" fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #fef2f2", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: "#fee2e2" }}>
                        <WarningAmberIcon sx={{ fontSize: 18, color: "#DC2626" }} />
                    </Avatar>
                    <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#DC2626" fontSize={16}>
                        Supprimer le Type de Coupon
                    </Typography>
                </Box>
                {!deleting && <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>}
            </DialogTitle>

            <DialogContent sx={{ pt: "20px !important", px: 3, pb: 2 }}>
                <Typography fontFamily="Montserrat, sans-serif" fontSize={14} color="#374151">
                    Voulez-vous vraiment supprimer le type de coupon{" "}
                    <strong>"{couponType.name}"</strong> ?
                </Typography>
                <Typography fontSize={12} color="#6B7280" mt={1}>
                    Cette action est irréversible. Les catégories de récompenses associées ne pourront plus être supprimées si ce type est lié.
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #f0f0f0", gap: 1 }}>
                <Button onClick={onClose} disabled={deleting}
                    sx={{ color: "text.secondary", textTransform: "none" }}>
                    Annuler
                </Button>
                <Button variant="contained" onClick={onConfirm} disabled={deleting}
                    startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
                    sx={{ bgcolor: "#DC2626", "&:hover": { bgcolor: "#B91C1C" }, textTransform: "none", borderRadius: 2, fontWeight: 600, px: 3 }}>
                    {deleting ? "Suppression..." : "Supprimer"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteCouponTypeDialog;
